<template>
  <span class="pega-break">
    <div class="boss-layout boss-layout-gap-between">
      <div class="boss-resume-sheet-title pega-resume-sheet-title">履歴書</div>
    </div>
    <div class="boss-layout-block">
      <div class="boss-table-wrap">
        <table class="boss-table-4 boss-table-4-responsive pega-th-color-important pega-print-resume-table">
          <tr>
            <th>セミナー</th>
            <td
              colspan="4"
              data-test="seminar-name"
            >{{ resume.seminarName }}</td>
            <td
              rowspan="6"
              class="boss-table-4-plain boss-resume-sheet-photo-space-cell padding-bottom-1"
            >
              <div class="boss-resume-sheet-photo-space-layout">
                <div class="is-boss-only-pc">
                  <div class="boss-resume-sheet-photo-space" />
                </div>
                <div data-test="user-id">会員ID：{{ resume.userId }}</div>
              </div>
            </td>
          </tr>
          <tr>
            <th>セミナー日時</th>
            <td
              colspan="4"
              data-test="seminar-date-time"
            >{{ resume.seminarDate | formatDate }} {{ resume.seminarTime }}</td>
          </tr>
          <tr>
            <td
              class="boss-table-4-space"
              colspan="4"
            />
          </tr>
          <tr>
            <th>フリガナ</th>
            <td
              colspan="4"
              data-test="name-kana"
            >{{ userNameKana }}</td>
          </tr>
          <tr>
            <th>氏名</th>
            <td
              colspan="4"
              data-test="name"
            >{{ userName }}</td>
          </tr>
          <tr>
            <th>生年月日</th>
            <td
              colspan="2"
              data-test="birthday"
            >{{ resume.birthday | formatDate }} {{ ageLabel }}</td>
            <th>性別</th>
            <td
              class="text-nowrap"
              data-test="gender"
            >{{ resume.gender | parseBlankForDefaultValue }}</td>
          </tr>
          <tr>
            <th rowspan="2">現住所</th>
            <td
              colspan="5"
              data-test="zip"
            >{{ formatZip }}</td>
          </tr>
          <tr>
            <td
              colspan="5"
              data-test="address"
            >{{ resume.address }}</td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td
              data-test="tel"
              colspan="2"
            >{{ resume.tel | parseBlankForDefaultValue }}</td>
            <th>携帯電話番号</th>
            <td
              colspan="2"
              class="text-nowrap"
              data-test="mobile"
            >{{ resume.mobile | parseBlankForDefaultValue }}</td>
          </tr>
          <tr>
            <th>メールアドレス</th>
            <td
              colspan="2"
              data-test="email"
              class="pega-break"
            >{{ resume.email | parseBlankForDefaultValue }}</td>
            <th>携帯メールアドレス</th>
            <td
              colspan="2"
              data-test="email-mobile"
              class="pega-break"
            >{{ resume.emailMobile | parseBlankForDefaultValue }}</td>
          </tr>
          <tr>
            <td
              class="boss-table-4-space"
              colspan="6"
            />
          </tr>
          <tr>
            <th colspan="6">学歴</th>
          </tr>
          <tr>
            <td
              colspan="6"
              data-test="graduated-school"
            >{{ resume.graduatedSchool }} {{ resume.educationDepartment }} {{
              graduateLabel
            }} (最終学歴:{{ resume.lastEducationalBackground | parseBlankForDefaultValue }})
              <div data-test="graduated-school-department-category">
                学部・学科コード: {{ resume.educationDepartmentCategory | parseBlankForDefaultValue }}
              </div>
            </td>
          </tr>
          <tr>
            <th colspan="6">職務経歴（概略）</th>
          </tr>
          <tr>
            <td
              colspan="6"
              data-test="experience-company"
            >{{ resume.recentExperienceCompanyName }} {{ resume.recentExperienceCompanyEmploymentStatusName }}
              <div data-test="experience-company-business">
                {{ resume.recentExperienceCompanyBusinessCategoryName }}
              </div>
            </td>
          </tr>
          <tr>
            <td
              class="boss-table-4-space"
              colspan="6"
            />
          </tr>
          <tr>
            <th>就業状況</th>
            <td
              colspan="2"
              data-test="working-status-name"
            >{{ resume.workingStatusName | parseBlankForDefaultValue }}</td>
            <th>直近の経験職種</th>
            <td
              colspan="2"
              data-test="recent-job-name"
            >{{ resume.recentJobName | parseBlankForDefaultValue }}</td>
          </tr>
          <template v-if="resume.seminarOriginalQuestionAndAnswers">
            <tr data-test="original-question">
              <td
                class="boss-table-4-space"
                colspan="6"
              />
            </tr>
            <template v-if="resume.seminarOriginalQuestionAndAnswers.question1">
              <tr data-test="question-answer-1">
                <th>質問1</th>
                <td
                  colspan="5"
                  class="pega-pre-wrap"
                >
                  <span data-test="question1">Q: {{ resume.seminarOriginalQuestionAndAnswers.question1 }}</span>
                  <br><br>
                  <span
                    data-test="answer1"
                  >A: {{ resume.seminarOriginalQuestionAndAnswers.answer1 | parseBlankForDefaultValue }}</span>
                </td>
              </tr>
            </template>
            <template v-if="resume.seminarOriginalQuestionAndAnswers.question2">
              <tr data-test="question-answer-2">
                <th>質問2</th>
                <td
                  colspan="5"
                  class="pega-pre-wrap"
                >
                  <span data-test="question2">Q: {{ resume.seminarOriginalQuestionAndAnswers.question2 }}</span>
                  <br><br>
                  <span
                    data-test="answer2"
                  >A: {{ resume.seminarOriginalQuestionAndAnswers.answer2 | parseBlankForDefaultValue }}</span>
                </td>
              </tr>
            </template>
            <template v-if="resume.seminarOriginalQuestionAndAnswers.question3">
              <tr data-test="question-answer-3">
                <th>質問3</th>
                <td
                  colspan="5"
                  class="pega-pre-wrap"
                >
                  <span data-test="question3">Q: {{ resume.seminarOriginalQuestionAndAnswers.question3 }}</span>
                  <br><br>
                  <span
                    data-test="answer3"
                  >A: {{ resume.seminarOriginalQuestionAndAnswers.answer3 | parseBlankForDefaultValue }}</span>
                </td>
              </tr>
            </template>
          </template>
        </table>
      </div>
    </div>
  </span>
</template>

<script>
import dayjs from 'dayjs'
import * as parse from '@/lib/parse'
import _ from 'lodash'

export default {
  filters: {
    formatDate (date) {
      return date ? dayjs(date).format('YYYY年MM月DD日') : ''
    },
    parseBlankForDefaultValue (label, suffix = '') {
      return label ? label + suffix : '未登録'
    }
  },
  props: {
    entryId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      resume: {
        seminarName: '',
        seminarDate: '',
        seminarTime: '',
        userId: undefined,
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        birthday: '',
        gender: '',
        zip: '',
        address: '',
        tel: '',
        mobile: '',
        email: '',
        emailMobile: '',
        lastEducationalBackground: '',
        graduatedSchool: '',
        educationDepartment: '',
        educationDepartmentCategory: '',
        recentExperienceCompanyName: '',
        recentExperienceCompanyEmploymentStatusName: '',
        recentExperienceCompanyBusinessCategoryName: '',
        workingStatusName: '',
        recentJobName: '',
        seminarOriginalQuestionAndAnswers: {
          question1: '',
          answer1: '',
          question2: '',
          answer2: '',
          question3: '',
          answer3: ''
        }
      }
    }
  },
  computed: {
    userNameKana () {
      return [this.resume.lastNameKana, this.resume.firstNameKana].join(' ')
    },
    userName () {
      return [this.resume.lastName, this.resume.firstName].join(' ')
    },
    ageLabel () {
      const birthday = _.get(this.resume, 'birthday')
      return birthday ? `(満${parse.age(birthday)}歳)` : ''
    },
    formatZip () {
      const zip = _.get(this.resume, 'zip')
      return zip ? `〒${zip}` : ''
    },
    graduateLabel () {
      return this.resume.graduatedSchool || this.resume.educationDepartment ? '卒業' : ''
    }
  },
  watch: {
    entryId: {
      handler () {
        this.fetchResume()
      }
    }
  },
  created () {
    this.fetchResume()
  },
  methods: {
    fetchResume () {
      this.$http.secured.get(`/seminar/entries/${this.entryId}/resume`).then(response => {
        this.setResume(response.data)
      })
    },
    setResume (data) {
      this.$set(this, 'resume', data)
    }
  }
}

</script>
